// extracted by mini-css-extract-plugin
module.exports = {"categoryMenu":"_3TBTo3k","item":"_2PRDtJh"};